import type { DocPage } from "../types";

export const page: DocPage = {
  slug: "skills-and-files",
  title: "Skills and files",
  navLabel: "Skills and files",
  description:
    "Choose the guidance available to the Agent and manage reports, exports, and uploads saved to your Mavori account.",
  section: "automation",
  published: "2026-08-03",
  updated: "2026-08-03",
  related: ["agent", "mcp", "account"],
  blocks: [
    {
      type: "lead",
      text: "Skills shape how the Agent approaches specialized work. Files hold the reports, exports, and uploads that make that work durable and available across conversations.",
    },

    { type: "h2", text: "Choose the Agent's skills" },
    {
      type: "p",
      text: "Open **Skills** to review the guidance available to the Agent. The **Installed skills** view combines Mavori's built-in analysis skills with skills added to your account. Use the Enabled and Disabled filters to understand the current set, and switch a skill on when you want it available by default. A skill supplies a repeatable method or area of expertise; it does not replace the facts and sources used for a specific answer.",
    },

    { type: "h2", text: "Add and manage skills" },
    {
      type: "p",
      text: "Use the **Skill marketplace** to discover public skills and install the ones that fit your work. You can also select **Install skill** to add your own packaged skill. Installed skills can be enabled, disabled, updated, or removed from the same page. If you publish a skill to the marketplace, its public version is reviewed separately from the copy installed in your account.",
    },

    { type: "h2", text: "Use Files as your library" },
    {
      type: "p",
      text: "Open **Files** to browse everything the Agent has saved, together with files you uploaded. The explorer keeps folders and full file names visible; select a file to open its preview. Text files can be edited and saved in place, while files you no longer need can be deleted from their preview. Reports and exports created in one conversation remain available in later conversations.",
    },

    { type: "h2", text: "Bring skills and files into a conversation" },
    {
      type: "p",
      text: "Start from the Agent when you want to apply a skill or work from an existing file. Name the skill or file when it matters, and state the outcome you want rather than asking for a generic analysis. For recurring work, a [scheduled task](/docs/automations) can pin selected skills so each run starts with the same approach. External tool access is managed separately on the [MCP connections](/docs/mcp) page.",
    },
  ],
};
